// extracted by mini-css-extract-plugin
export var cell = "_6r-4";
export var headerCell = "_6r-2";
export var rowHeader = "_6r-3";
export var table = "_6r-1";
export var tableContainer = "_6r-0";